(function () {
  function initWeather(block) {
    if (block.dataset.bound) return;
    block.dataset.bound = 'true';

    const lat = block.dataset.lat;
    const lon = block.dataset.lon;
    const unit = block.dataset.unit;
    const API_KEY = block.dataset.apiKey;

    const tempEl = block.querySelector('.temp');
    const descEl = block.querySelector('.desc');
    const timeEl = block.querySelector('.time');
    const greetingEl = block.querySelector('.greeting');
    const locationEl = block.querySelector('.location p');


    fetch(
      `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=${unit}&appid=${API_KEY}`
    )
      .then((r) => r.json())
      .then((data) => {
        tempEl.innerText =
          Math.round(data.main.temp) + (unit === 'imperial' ? '°F' : '°C');
        descEl.innerText = data.weather[0].description;
      });

        function updateTimeAndGreeting() {
            const now = new Date();

            const formatter = new Intl.DateTimeFormat('en-US', {
                timeZone: 'America/New_York',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            });

            const parts = formatter.formatToParts(now);
            const hour = now.getHours();

            let greeting = 'Good Evening';
            if (hour >= 5 && hour < 12) greeting = 'Good Morning';
            else if (hour >= 12 && hour < 17) greeting = 'Good Afternoon';
            else if (hour >= 17 && hour < 22) greeting = 'Good Evening';
            else greeting = 'Good Night';

            timeEl.innerText = formatter.format(now) + ' EST';
            if (greetingEl) greetingEl.innerText = greeting;
        }

        if (locationEl && !locationEl.dataset.split) {
            locationEl.dataset.split = 'true';

            const text = locationEl.innerText.trim();
            locationEl.innerHTML = '';

            text.split('').forEach((char) => {
                const span = document.createElement('span');
                span.textContent = char === ' ' ? '\u00A0' : char;
                locationEl.appendChild(span);
            });
        }



    updateTimeAndGreeting();
    setInterval(updateTimeAndGreeting, 60000);
  }

  function initAll() {
    document.querySelectorAll('.p7-weather').forEach(initWeather);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();

    const observer = new MutationObserver(initAll);
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

})();
